export default __webpack_public_path__ + "static/media/denys.ef965e55.jpg";